import React, { useRef, useState } from 'react'
import styles from './ProductImagesSwiper.module.scss'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { FreeMode, Keyboard, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { SolarProductImage } from '../../../../model/solar-product/solar-product-image';
import CommonDialog from '../../../../common/components/dialog/CommonDialog';

type Props = {
    images: SolarProductImage[] | undefined;
}

const ProductImagesSwiper: React.FC<Props> = (props: Props) => {
    const { images } = props;
    const swiperRef = useRef<SwiperRef>(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const [open, setOpen] = useState<boolean>(false);
    const [currentImage, setCurrentImage] = useState<string | null>(null);

    const handleNext = () => {
        swiperRef?.current?.swiper?.slideNext();
    };

    const handlePrev = () => {
        swiperRef?.current?.swiper?.slidePrev();
    }

    const handleSlideChange = () => {
        setIsBeginning(swiperRef?.current?.swiper?.isBeginning ?? isBeginning);
        setIsEnd(swiperRef?.current?.swiper?.isEnd ?? isEnd);
    };

    const handleImageClick = (imageUrl: string) => {
        setCurrentImage(imageUrl);
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setCurrentImage(null);
    }

    return (
        <div className={styles.container}>
            <Swiper
                ref={swiperRef}
                spaceBetween={10}
                // loop
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                }}
                keyboard={{
                    enabled: true,
                }}
                modules={[FreeMode, Keyboard, Autoplay]}
                className={styles.mySwiper}
                onSlideChange={handleSlideChange}
                onInit={handleSlideChange}
            >
                {images?.map((x: SolarProductImage) => (
                    <SwiperSlide>
                        <img src={x.imageUrl} alt="Product" className={styles.productImage} onClick={() => handleImageClick(x.imageUrl)} />
                    </SwiperSlide>        
                ))}
                <div onClick={handlePrev} className={`${styles.arrow} ${styles.arrowPrev} ${isBeginning ? styles.none : ''}`}>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12.5H19" stroke="#6C7275" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M5 12.5L11 18.5" stroke="#6C7275" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M5 12.5L11 6.5" stroke="#6C7275" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <div onClick={handleNext} className={`${styles.arrow} ${styles.arrowNext} ${isEnd ? styles.none : ''}`}>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12.5L5 12.5" stroke="#141718" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M19 12.5L13 6.5" stroke="#141718" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M19 12.5L13 18.5" stroke="#141718" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </Swiper>

            {open && (
                <CommonDialog onCloseDialog={handleClose}>
                    {currentImage && (
                        <img
                            src={currentImage}
                            alt="Zoomed Product"
                            className={styles.zoomedImage}
                        />
                    )}
                </CommonDialog>
            )}
        </div>
  );
}

export default ProductImagesSwiper